import React from 'react'
import '../../styles/Utils/Badge.css'

{/*
<Badge 
    theme={'grey | blue | green | red'} 
    rounded={false}
    text={""} 
/>
--badgeLight: #ffffff;
--badgeDark: #89a58d;
--badgeGrey: #7e7e7e;
--badgeBlue: #617e91;
--badgeGreen: #89a58d;
--badgeRed: #be5959;
*/}

function Badge({ theme, text, rounded, active, onClick }) {

    return (

        <div
            className={[
                'badge', rounded ? 'badgeRounded' : null,
                (onClick && theme === 'light') ? 'badgeLightClickable' : (onClick && theme === 'dark') ? 'badgeDarkClickable' : null,
                theme === 'light' ? 'badgeLight' : theme === 'dark' ? 'badgeDark' : theme === 'grey' ? 'badgeGrey' : theme === 'blue' ? 'badgeBlue' : theme === 'green' ? 'badgeGreen' : theme === 'red' ? 'badgeRed' : null,
                (active && theme === 'light') ? 'badgeLightActive' : (active && theme === 'dark') ? 'badgeDarkActive' : null,
            ].join(" ")}
            onClick={onClick}>
            {text}
        </div>

    )

}

export default Badge